import { render, staticRenderFns } from "./privacy_policy_component.vue?vue&type=template&id=0b9dd290&scoped=true&"
import script from "./privacy_policy_component.vue?vue&type=script&lang=js&"
export * from "./privacy_policy_component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9dd290",
  null
  
)

export default component.exports